import useLatest from 'app/hooks/use-latest'
import {
  createMerchPageQuery,
  mapToMerchPageContent,
} from 'app/queries/globals/merch'

import useQuery from './use-query'

const merchPageQuery = createMerchPageQuery()

const useMerchPage = () => {
  const pageContent = useQuery(merchPageQuery, {}, mapToMerchPageContent)
  const collection = pageContent.data?.merchCollection
  const search = useLatest('Collection', collection?.id, 12)

  return {
    pageContent,
    merchContent: search,
  }
}

export default useMerchPage
